import React, { useState, useEffect } from "react";
import config from "../../config";
import { City, Country, State } from "country-state-city";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Switch,
  VStack,
  HStack,
  Box,
  Grid,
  GridItem,
  useToast,
  Spinner,
} from "@chakra-ui/react";
import Select from "react-select";
import { userActivity } from "Utils";

// Sample data - replace with your actual data source
const countriesData = [
  { code: "IN", name: "India" },
  { code: "US", name: "United States" },
  { code: "UK", name: "United Kingdom" },
  { code: "CA", name: "Canada" },
  { code: "AU", name: "Australia" },
];

const statesData = {
  IN: [
    { code: "GJ", name: "Gujarat" },
    { code: "MH", name: "Maharashtra" },
    { code: "KA", name: "Karnataka" },
    { code: "TN", name: "Tamil Nadu" },
    { code: "DL", name: "Delhi" },
  ],
  US: [
    { code: "CA", name: "California" },
    { code: "NY", name: "New York" },
    { code: "TX", name: "Texas" },
    { code: "FL", name: "Florida" },
  ],
  UK: [
    { code: "ENG", name: "England" },
    { code: "SCT", name: "Scotland" },
    { code: "WLS", name: "Wales" },
  ],
};

const citiesData = {
  GJ: [
    { name: "Ahmedabad" },
    { name: "Surat" },
    { name: "Vadodara" },
    { name: "Rajkot" },
  ],
  MH: [
    { name: "Mumbai" },
    { name: "Pune" },
    { name: "Nagpur" },
    { name: "Nashik" },
  ],
  CA: [
    { name: "Los Angeles" },
    { name: "San Francisco" },
    { name: "San Diego" },
    { name: "Sacramento" },
  ],
  NY: [
    { name: "New York City" },
    { name: "Buffalo" },
    { name: "Rochester" },
    { name: "Syracuse" },
  ],
};

function AddAndUpdateClientBranchModal({
  isOpen,
  onClose,
  existingData = null,
  clients = [],
  contactPersons = [],
  onSubmit,
  client,
  fetchAllBranches,
  city,
  state,
  userId,
  userRole,
  candidate_ownerName,
  accountName,
  alreadyPresentData,
}) {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    clientId: "",
    branchName: "",
    contactPersonId: "",
    phone: "",
    recuiterName: "",
    email: "",
    address: {
      street: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      stateCode: "",
      countryCode: "",
    },
    status: true, // Changed to boolean: true = Active, false = Inactive
    isMainBranch: false,
  });

  const isUpdateMode = Boolean(existingData);

  // Initialize form data when modal opens or existingData changes
  useEffect(() => {
    if (isOpen) {
      if (existingData) {
        setFormData({
          clientId: existingData?.clientId || "",
          branchName: existingData?.branchName || "",
          recuiterName: existingData?.recuiterName || "",
          contactPersonId: existingData?.contactPersonId?._id || "",
          phone: existingData?.phone || "",
          email: existingData?.email || "",
          address: {
            street: existingData?.address?.street || "",
            city: existingData?.address?.city || "",
            state: existingData?.address?.state || "",
            country: existingData?.address?.country || "",
            pincode: existingData?.address?.pincode || "",
            stateCode: existingData?.address?.stateCode || "",
            countryCode:existingData?.address?.countryCode || "",
          },
          status:
            existingData?.status === "Active" || existingData?.status === true, // Convert to boolean
          isMainBranch: existingData?.isMainBranch || false,
        });
      } else if (alreadyPresentData) {
        setFormData({
          clientId: alreadyPresentData?.clientId || "",
          branchName: alreadyPresentData?.branchName || "",
          recuiterName: alreadyPresentData?.recuiterName || "",
          contactPersonId: alreadyPresentData?.contactPersonId?._id || "",
          phone: alreadyPresentData?.phone || "",
          email: alreadyPresentData?.email || "",
          address: {
            street: alreadyPresentData?.address?.street || "",
            city: alreadyPresentData?.address?.city || "",
            state: alreadyPresentData?.address?.state || "",
            country: alreadyPresentData?.address?.country || "",
            pincode: alreadyPresentData?.address?.pincode || "",
            countryCode:
              getCountryCodeByName(alreadyPresentData?.address?.country) || "",
            stateCode: getStateCodeByName(
              alreadyPresentData?.address?.state,
              getCountryCodeByName(alreadyPresentData?.address?.country)
            ),
          },
          status:
            alreadyPresentData?.status === "Active" ||
            alreadyPresentData?.status === true, // Convert to boolean
          isMainBranch: alreadyPresentData?.isMainBranch || false,
        });
      } else {
        // Reset form for new entry
        setFormData({
          clientId: client?.value || client?._id || "",
          branchName: "",
          recuiterName: "",
          contactPersonId: "",
          phone: "",
          email: "",
          address: {
            street: "",
            city: "",
            state: "",
            country: "",
            pincode: "",
            stateCode: "",
            countryCode: "",
          },
          status: true, // Default to Active
          isMainBranch: false,
        });
      }
    }
  }, [isOpen, existingData, client, alreadyPresentData]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name.includes("address.")) {
      const addressField = name.split(".")[1];

      // Handle cascading dropdowns for location
      if (addressField === "countryCode") {
        // Clear state and city when country changes
        setFormData((prev) => ({
          ...prev,
          address: {
            ...prev.address,
            [addressField]: value,
            country: countriesData.find((c) => c.code === value)?.name || "",
            stateCode: "",
            state: "",
            city: "",
          },
        }));
      } else if (addressField === "stateCode") {
        // Clear city when state changes
        const selectedCountryCode = formData.address.countryCode;
        const selectedState = statesData[selectedCountryCode]?.find(
          (s) => s.code === value
        );

        setFormData((prev) => ({
          ...prev,
          address: {
            ...prev.address,
            [addressField]: value,
            state: selectedState?.name || "",
            city: "",
          },
        }));
      } else if (addressField === "city") {
        setFormData((prev) => ({
          ...prev,
          address: {
            ...prev.address,
            [addressField]: value,
          },
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          address: {
            ...prev.address,
            [addressField]: value,
          },
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  // Handle React Select changes
  const handleSelectChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    const value = selectedOption ? selectedOption.value : "";

    if (name.includes("address.")) {
      const addressField = name.split(".")[1];

      // Handle cascading dropdowns for location
      if (addressField === "countryCode") {
        // Clear state and city when country changes
        setFormData((prev) => ({
          ...prev,
          address: {
            ...prev.address,
            [addressField]: selectedOption.isoCode,
            country: selectedOption ? selectedOption.name : "",
            stateCode: "",
            state: "",
            city: "",
          },
        }));
      } else if (addressField === "stateCode") {
        // Clear city when state changes
        setFormData((prev) => ({
          ...prev,
          address: {
            ...prev.address,
            [addressField]: selectedOption.isoCode,
            state: selectedOption ? selectedOption.name : "",
            city: "",
          },
        }));
      } else if (addressField === "city") {
        setFormData((prev) => ({
          ...prev,
          address: {
            ...prev.address,
            [addressField]: selectedOption.isoCode,
            city: selectedOption ? selectedOption.name : "",
          },
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const getSelectedContactPerson = () => {
    const selectedContactPerson = contactPersons.find(
      (person) => person.value === formData.contactPersonId
    )
      ? {
          value: formData.contactPersonId,
          label: contactPersons.find(
            (person) => person.value === formData.contactPersonId
          ).label,
        }
      : null;
    return selectedContactPerson;
  };

  const validateForm = () => {
    if (!formData.clientId) {
      toast({
        title: "Validation Error",
        description: "Please select a client",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }

    if (!formData.branchName.trim()) {
      toast({
        title: "Validation Error",
        description: "Branch name is required",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }

    if (!formData.contactPersonId) {
      toast({
        title: "Validation Error",
        description: "Please select a contact person",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      const url = isUpdateMode
        ? `${config.apiUrl}/api/update_branch/${existingData._id}`
        : `${config.apiUrl}/api/add_new_branch`;

      const method = isUpdateMode ? "PATCH" : "POST";

      // Convert boolean status back to string for API
      const submitData = {
        ...formData,
        status: formData.status ? "Active" : "Inactive",
      };

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData),
      });

      if (!response.ok) {
        throw new Error(
          `Failed to ${isUpdateMode ? "update" : "create"} client branch`
        );
      }

      const result = await response.json();
      fetchAllBranches && fetchAllBranches();
      toast({
        title: "Success",
        description: `Client branch ${
          isUpdateMode ? "updated" : "created"
        } successfully`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      const activityOn = `${isUpdateMode ? "updated" : "created"}${existingData?.branchName || submitData.branchName} branch in the ${accountName} `;
      const activityDo = `branch ${isUpdateMode ? "updated" : "created"}`;
      const reData = {
        name: `${accountName}`,
        id: result._id,
        action: isUpdateMode ? "editBranch" : "addBranch",
        type: "branch",
        note: null,
      };
      userActivity(
        candidate_ownerName,
        userId,
        "branch",
        activityDo,
        activityOn,
        userRole,
        reData
      );
      // Call the onSubmit callback if provided
      if (onSubmit) {
        onSubmit(result);
      }

      onClose();
    } catch (error) {
      console.error("Error:", error);
      toast({
        title: "Error",
        description:
          error.message ||
          `Failed to ${isUpdateMode ? "update" : "create"} client branch`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };
const getCountryCodeByName = (countryName) => {
  const country = Country.getAllCountries().find(
    (c) => c.name.toLowerCase() === countryName.toLowerCase()
  );
  return country ? country.isoCode : null;
};
const getStateCodeByName = (state, code) => {
  const country = State.getStatesOfCountry(code).find(
    (c) => c.name.toLowerCase() === state.toLowerCase()
  );
  return country ? country.isoCode : null;
};
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {isUpdateMode ? "Update Client Branch" : "Add New Client Branch"}
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack spacing={4} align="stretch">
            {/* Basic Information */}
            <Box>
              <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                <GridItem>
                  <FormControl isRequired>
                    <FormLabel>Client</FormLabel>
                    <Select
                      name="clientId"
                      value={client}
                      options={clients.map((client) => ({
                        label: client.name || client.clientName || client.label,
                        value: client._id || client.value,
                      }))}
                      isDisabled={!!client} // Disable if client is pre-selected
                      onChange={handleSelectChange}
                      placeholder="Select client"
                      isClearable
                    />
                  </FormControl>
                </GridItem>

                <GridItem>
                  <FormControl isRequired>
                    <FormLabel>Branch Name</FormLabel>
                    <Input
                      name="branchName"
                      value={formData.branchName}
                      onChange={handleInputChange}
                      placeholder="Enter branch name"
                    />
                  </FormControl>
                </GridItem>
              </Grid>
            </Box>

            {/* Contact Information */}
            <Box>
              <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                <GridItem>
                  <FormControl isRequired>
                    <FormLabel>Contact Person</FormLabel>
                    <Select
                      name="contactPersonId"
                      value={getSelectedContactPerson()}
                      onChange={handleSelectChange}
                      options={contactPersons}
                      placeholder="Select contact person"
                      isClearable
                    />
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl isRequired>
                    <FormLabel>Interviewer</FormLabel>
                    <Input
                      name="recuiterName"
                      // value={getSelectedContactPerson()}
                      value={formData.recuiterName}
                      onChange={handleInputChange}
                      options={contactPersons}
                      placeholder="Interviewer Name"
                      isClearable
                    />
                  </FormControl>
                </GridItem>
              </Grid>
            </Box>

            {/* Contact Details */}
            <Box>
              <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                <GridItem>
                  <FormControl>
                    <FormLabel>Phone</FormLabel>
                    <Input
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="Enter phone number"
                    />
                  </FormControl>
                </GridItem>

                <GridItem>
                  <FormControl>
                    <FormLabel>Email</FormLabel>
                    <Input
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Enter email address"
                    />
                  </FormControl>
                </GridItem>
              </Grid>
            </Box>

            {/* Address Information */}
            <Box>
              <FormLabel fontWeight="bold" mb={3}>
                Address
              </FormLabel>
              <VStack spacing={3}>
                <FormControl>
                  <FormLabel>Street</FormLabel>
                  <Input
                    name="address.street"
                    value={formData.address.street}
                    onChange={handleInputChange}
                    placeholder="Enter street address"
                  />
                </FormControl>

                <Grid templateColumns="repeat(3, 1fr)" gap={4} width="100%">
                  <GridItem>
                    <FormControl>
                      <FormLabel>Country</FormLabel>
                      <Select
                        name="address.countryCode"
                        value={
                          formData?.address?.countryCode
                            ? {
                                name: formData?.address?.country,
                                isoCode: formData?.address?.countryCode,
                              }
                            : null
                        }
                        onChange={handleSelectChange}
                        getOptionLabel={(options) => options["name"]}
                        getOptionValue={(options) => options["isoCode"]}
                        placeholder="Select country"
                        options={Country.getAllCountries()}
                        isClearable
                      />
                    </FormControl>
                  </GridItem>

                  <GridItem>
                    <FormControl>
                      <FormLabel>State</FormLabel>
                      <Select
                        name="address.stateCode"
                        value={
                          formData?.address.state
                            ? {
                                name: formData?.address?.state,
                                isoCode: formData?.address?.stateCode,
                              }
                            : null
                        }
                        options={State.getStatesOfCountry(
                          formData?.address?.countryCode
                        )}
                        placeholder="Select State"
                        getOptionLabel={(options) => options["name"]}
                        getOptionValue={(options) => options["isoCode"]}
                        onChange={handleSelectChange}
                        isDisabled={!formData.address.countryCode}
                        isClearable
                      />
                    </FormControl>
                  </GridItem>

                  <GridItem>
                    <FormControl>
                      <FormLabel>City</FormLabel>
                      <Select
                        name="address.city"
                        options={City.getCitiesOfState(
                          formData.address.countryCode,
                          formData.address.stateCode
                        )}
                        placeholder="Select City"
                        getOptionLabel={(options) => options["name"]}
                        getOptionValue={(options) => options["name"]}
                        value={
                          formData.address.city
                            ? { name: formData.address.city }
                            : null
                        }
                        onChange={handleSelectChange}
                        isDisabled={!formData.address.stateCode}
                        isClearable
                      />
                    </FormControl>
                  </GridItem>
                </Grid>

                <Grid templateColumns="repeat(2, 1fr)" gap={4} width="100%">
                  <GridItem>
                    <FormControl>
                      <FormLabel>Pincode</FormLabel>
                      <Input
                        name="address.pincode"
                        value={formData.address.pincode}
                        onChange={handleInputChange}
                        placeholder="Enter pincode"
                      />
                    </FormControl>
                  </GridItem>
                </Grid>
              </VStack>
            </Box>

            {/* Status and Settings */}
            <Box>
              <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                <GridItem>
                  <FormControl display="flex" alignItems="center">
                    <FormLabel mb="0">
                      Status ({formData.status ? "Active" : "Inactive"})
                    </FormLabel>
                    <Switch
                      name="status"
                      isChecked={formData.status}
                      onChange={handleInputChange}
                      colorScheme={formData.status ? "green" : "red"}
                    />
                  </FormControl>
                </GridItem>

                <GridItem>
                  <FormControl display="flex" alignItems="center">
                    <FormLabel mb="0">Main Branch</FormLabel>
                    <Switch
                      name="isMainBranch"
                      isChecked={formData.isMainBranch}
                      onChange={handleInputChange}
                    />
                  </FormControl>
                </GridItem>
              </Grid>
            </Box>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleSubmit}
            isLoading={loading}
            loadingText={isUpdateMode ? "Updating..." : "Creating..."}
          >
            {isUpdateMode ? "Update Branch" : "Create Branch"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default AddAndUpdateClientBranchModal;
